import React from 'react'
import PropTypes from 'prop-types'

import { Clear } from '@material-ui/icons'
import { createColorFullHeightDefaultButton } from '../buttons/defaultButton'

import { withLocalize } from 'react-localize-redux'

const ColoredButton = createColorFullHeightDefaultButton(theme => ({ color: theme.icon.baseOnWhite, hoverColor: theme.icon.hover }))

const ClearButton = ({ titleId, onClick, translate }) =>
  <ColoredButton title={translate(titleId ?? 'buttonClear')} color='inherit' variant='contained' size='small' onClick={onClick}>
    <Clear />
  </ColoredButton>

ClearButton.propTypes = {
  titleId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired
}

export default withLocalize(ClearButton)
